// extracted by mini-css-extract-plugin
module.exports = {"padding":"index-module--padding--gT2K7"};